/** The image field: `media-uploader.hook` restricted to the image types the endpoint accepts. */
import type { UseAssessmentMediaUploaderReturn } from './media-uploader.hook'

import { useAssessmentMediaUploader } from './media-uploader.hook'

export const ASSESSMENT_IMAGE_ACCEPT: string[] = ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.svg']

/** 5 MB — the client-side cap for images; the endpoint itself allows 80 MB. */
export const ASSESSMENT_IMAGE_MAX_SIZE = 5 * 1024 * 1024

export interface UseImageUploaderOptions {
  value: () => string | undefined
  onChange: (value: string) => void
}

export interface UseImageUploaderReturn extends Omit<UseAssessmentMediaUploaderReturn, 'refHasValue'> {
  refHasImage: UseAssessmentMediaUploaderReturn['refHasValue']
}

export const useImageUploader = ({ value, onChange }: UseImageUploaderOptions): UseImageUploaderReturn => {
  const { refHasValue, ...uploader } = useAssessmentMediaUploader({
    value,
    onChange,
    accept: ASSESSMENT_IMAGE_ACCEPT,
    maxSize: ASSESSMENT_IMAGE_MAX_SIZE,
    cannotUploadHint: 'Save the assessment template before uploading images.',
  })

  return {
    ...uploader,
    refHasImage: refHasValue,
  }
}
